const moduleName = 'filter-container',
    baseSelector = `.js-${moduleName}`,
    toggleSelector = `${baseSelector}-toggle`,
    baseEl = document.querySelector(baseSelector),
    toggleEl = document.querySelector(toggleSelector),
    openClassName = 'is-open';

function toggleFilter() {
    if (baseEl.classList.contains(openClassName)) {
        baseEl.classList.remove(openClassName);
        document.body.classList.remove('filter-is-open');

        return;
    }

    baseEl.classList.add(openClassName);
    document.body.classList.add('filter-is-open');
}

function init() {
    if (toggleEl && baseEl) {
        toggleEl.addEventListener('click', toggleFilter);

        setTimeout(toggleFilter, 3000);
    }
}

init();
